import moment from 'moment-timezone';
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import utils from '../../../services/utils';
import Button from '../../Buttons/Button/Button';
import FieldBold from '../../Fields/FieldBold/FieldBold';
import ProgressBar from '../../ProgressBar/ProgressBar';
import { ReactComponent as Calendar } from '../../../assets/icons/Calendar.svg';
import { ReactComponent as Trash } from '../../../assets/icons/Trash.svg';
import Tags from '../../Tags/Tags';
import InvoiceDetail from '../../Details/InvoiceDetail/InvoiceDetail';
import Context from '../../../store/context';

import classes from './InvoicePendingCard.module.scss';

const InvoicePendingCard = ({
  className,
  onClick,
  invoice,
  isChecked,
  payed = false,
  deleteHandler,
  isSupplier = false,
  isModal = false,
  refetch
}) => {
  const {
    modal: { showModal }
  } = useContext(Context);

  const containerClasses = [
    'card-check',
    payed ? classes['card-process'] : '',
    isModal ? classes['card-modal'] : classes['card-not-modal']
  ];
  if (isChecked) {
    containerClasses.push('border-selected');
  }
  if (className) {
    containerClasses.push(className);
  }

  const navigate = useNavigate();

  const onClickShowDetail = () => {
    
    showModal(<InvoiceDetail refetch={refetch} isEdit={invoice.typePurchase==='INVOICE'} invoice={invoice} isForPay={true} supplier={invoice.supplier} />);
  };
  /* const isTag = !isPayable || paymentProcessingState !== 'NONE'; */

  const { supplier, issueDate, dueDate, payedValue, pendingValue, totalValue, supplierId, typePurchase } = invoice;

  const invoiceDescription =
    invoice?.description ||
    invoice?.descriptionItems ||
    invoice?.items?.[0]?.description ||
    invoice?.items?.[0]?.nameProduct ||
    'N/A';

  const goSupplier = () => {
    const url = `/itemsupplier/${supplierId}`;
    navigate(url);
  };
  return (
    <div className={containerClasses.join(' ')}>
      <div className={classes.title}>
        <div className={classes.head}>
          {/* {!isSupplier && !payed && <span className={`${classes.business} semibold-18`}>{supplier}</span>} */}
          {!isSupplier && !payed && (
            <Button
              title={supplier}
              custom='tertiary'
              className={`${classes.business} text-ellipsis semibold-18`}
              onClick={goSupplier}>
              {supplier}
            </Button>
          )}

          {moment(dueDate).isSameOrBefore(moment()) && <Tags text='Vencido' type='orange' />}
        </div>
        {payed && (
          <div className={classes.delete}>
            <span {...(invoiceDescription && { title: invoiceDescription })} className={`${classes.description} text-ellipsis medium-16`}>
              {invoiceDescription}
            </span>
            <Button custom='quaternary' onClick={deleteHandler} Icon={Trash} color='gray'>
              Eliminar
            </Button>
          </div>
        )}

        {/* <span className={`${classes.number} semibold-18`}>#{id}</span> */}
        {!payed && (
          <span {...(invoiceDescription && { title: invoiceDescription })} className={`${classes.concept} text-ellipsis medium-16`}>
            {invoiceDescription}
          </span>
        )}
        <div className={classes['last-date']}>
          <Calendar /> <span className={`${classes.text} medium-16`}>Se emitió el {moment(issueDate).format('DD/MM/YYYY')}</span>
        </div>
      </div>

      <div className={classes.values}>
        {!payed && (
          <>
            <FieldBold className={classes.totalValue} title='PENDIENTE' value={utils.moneyFormat(pendingValue)} />
          </>
        )}
        {payed && <span className='semibold-18'>{utils.moneyFormat(pendingValue)} pendientes</span>}
      </div>
      <span className={`${classes['value-mobile']} semibold-18`}>{utils.moneyFormat(pendingValue)} pendientes</span>
      <ProgressBar value={payedValue} max={totalValue} />
      {payed && <span className={`${classes.subscriber} medium-16`}>Monto abonado {utils.moneyFormat(payedValue)}</span>}
      {!payed && (
        <div className={classes['content-bottom']}>
          <div className={classes.totals}>
            <span className={`semibold-14`}>Total {utils.moneyFormat(totalValue)} </span>
            <span className={`${classes.color} medium-12`}>*Valor después de retenciones</span>
          </div>
          <Button onClick={onClickShowDetail} className={`${classes.button} semibold-16`} custom='quaternary'>
            Ver detalles
          </Button>
          {typePurchase === 'CHARGE' && <Tags text='Cobro' type='orange' />}
        </div>
      )}
    </div>
  );
};

export default InvoicePendingCard;
